import { customizationParser } from "./services/helpers/customization-helper";

// Base assets with branding-specific paths
const defaultAssets = {
  policeLine: "img/default/win-barrier.png",
  coinImage: "img/default/win-coin.png",
  musicLoop: "sounds/default/background-music-theme.mp3",
  fire: "img/default/winning-streak.png",
  playerRun: Array.from({ length: 18 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_run_side/Football_player_run_side_0000_000${imageIndex}.png`;
  }),
  playerHurt: Array.from({ length: 35 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_hurt/Football_player_hurt_0000_000${imageIndex}.png`;
  }),
  playerRunBlackHair: Array.from({ length: 40 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_run_black_hair/Football_player_run_black_hair_000${imageIndex}.png`;
  }),
  playerRunWhiteHair: Array.from({ length: 40 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_run_light_hair/Football_player_run_light_hair_000${imageIndex}.png`;
  }),
  playerTackleImages: Array.from({ length: 18 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_slider/Football_player_slider_000${imageIndex}.png`;
  }),
  playerIdle: Array.from({ length: 40 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_idle/Football_player_idle_0000_000${imageIndex}.png`;
  }),
  playerWon: Array.from({ length: 35 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_jump/Football_player_jump_0000_000${imageIndex}.png`;
  }),
};

const brandingAssets = {
  winner: {
    policeLine: "img/winner/win-barrier.png",
    coinImage: "img/winner/win-coin.png",
    musicLoop: "sounds/winner/background-music-theme.mp3",
  }
};


// Function to get branding assets based on the current branding
const getCurrentAssets = (branding = "default") => {
  return {
    ...defaultAssets,
    ...(brandingAssets[branding] || {}),
  };
};

const customization = customizationParser();

// Set the current branding somewhere in your app initialization
const currentBranding = customization?.branding || ""; // replace with actual branding logic

// Export assets based on the current branding
export const assets = getCurrentAssets(currentBranding);
